import { render, staticRenderFns } from "./createAssetType.vue?vue&type=template&id=121b452d&scoped=true"
import script from "./createAssetType.vue?vue&type=script&lang=js"
export * from "./createAssetType.vue?vue&type=script&lang=js"
import style0 from "./createAssetType.vue?vue&type=style&index=0&id=121b452d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b452d",
  null
  
)

export default component.exports